import {Component, ElementRef, Input, OnInit, QueryList, ViewChild, ViewChildren} from '@angular/core';
import {Router} from "@angular/router";
import {JoinServerModel} from "../../models/join-server.model";
import {Location} from '@angular/common';
import {NgForm} from "@angular/forms";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { NgxSelectModule, NgxSelectComponent, INgxSelectOptions } from 'ngx-select-ex';
import {ApiEndpoints} from "../../services/api-endpoints";

declare var $: any;

@Component({ standalone: false, 
  selector: 'app-create-join-servers',
  templateUrl: './create-join-servers.component.html',
})
export class CreateJoinServersComponent implements OnInit {
  public joinServerModel: JoinServerModel;
  public noValid: boolean =  false;
  public nameExist;
  public disableName = false;
  public joinIdExist = false;
  public disableSaveButton = false;
  public duplicatesExist = false;
  public duplicateError = false;
  public allPlatforms: any[] = [];
  public platformExists = false;
  public authTypes: string[] = ['NoAuth', 'BasicAuth']
  public httpModes: string[] = ['Async', 'Sync', 'Both']
  public securityOptions: string[] = ['None', 'SSL']
  public protocolVersions: string[] = ['1.0', '1.1']
  public trackingPattern: any[] = [];
  public ownerArrayWithId: any[] = [];
  public showSearch = false;
  public showPrimarySearch = false;
  public showSecondarySearch = false;
  public hasError = false;
  public doNotHaveJoinEUI = true;
  public trackingArr = [];
  public trackingCheck = [];
  public validPattern = false;
  public patternError = false;
  public ownerArray:Array<string> = [];
  private value:any = {};
  public validURL = false;
  public errorValidURL = false;
  public patternURL  = false;
  public patternClaimURL = true;
  public errorPatternURL = false;
  public errorPatternClaimURL = false;

  public class = ["ng-valid", "ng-touched", "ng-dirty"];
  public errorClass = ["ng-pristine", "ng-invalid", "ng-touched"];

  @Input() validationType;
  @ViewChild('inputJoinEUI') inputJoinEUI: ElementRef;
  @ViewChild('validate') validate: NgForm;

  constructor(private router: Router,
              private _location: Location,
              private http: HttpClient) {

    this.joinServerModel = new JoinServerModel()
  }

  // Live Search functions

  public selectedOwner(value:any):void {
    this.joinServerModel.owner = value.split(",", 1)[0] ;
  }

  // Select a Platform from live search list

  public selectedPlatform(value:any):void {
    this.joinServerModel.platformId = value.split(",",1)[0];
    this.platformExists = true;
  }

  public selectedHttpMode(value:any): void {
    this.joinServerModel.httpMode = value.split(",",1)[0];
  }

  public selectedAuthType(value:any): void {
    this.joinServerModel.authType = value.split(",",1)[0];
  }

  public selectedSecurity(value: any): void {
    this.joinServerModel.security = value.split(",",1)[0];
  }

  public selectedProtocolVersion(value:any): void {
    this.joinServerModel.protocolVersion = value.split(",", 1)[0];
  }

  public removedOwner(value:any):void {
    this.joinServerModel.owner = "";
  }

  public removedPlatform(value:any):void {
    this.joinServerModel.platformId = "";
    this.platformExists = false;
  }

  private hex2bin(hex: string, length: number) {
    var mask = "";
        if(hex.length == 16) {
            mask = "00000000000000000000000000000000";
            if(!length) length = 64;
        } else {
            mask = "000000000000";
            if(!length) length = 24;
        }
        //Divide the hex string to two halves and decode each half separately as parseInt hits overflow limits
        var hexAsBinaryLeft = parseInt(hex.substr(0, hex.length / 2), 16).toString(2);
        var hexAsBinaryRight = parseInt(hex.substr(hex.length / 2, hex.length /2), 16).toString(2);
        var hexAsBinaryLeftStr = (mask + hexAsBinaryLeft).substr(-mask.length);
        var hexAsBinaryRightStr = (mask + hexAsBinaryRight).substr(-mask.length);
        var binStr = (hexAsBinaryLeftStr + hexAsBinaryRightStr).substr(0, length);
        return binStr;
  }

  // Validation fields

  trimValue(event) {
    event.target.value = event.target.value.replace(/\s\s+/g, ' ');
  }

  validateName(name, nameElement) {
    this.nameExist = false;
    nameElement.classList.remove(...this.class);

    if(name.trim().length == 0){
      this.disableName = true;
      nameElement.classList.remove(this.class);
      nameElement.classList.add(this.errorClass);
    } else {
      const headers = new HttpHeaders({'Content-Type':  'application/json'});
      let options =  {headers: headers};
      var url = ApiEndpoints.EXISTS_NAME;
      name = name.replace(/\s\s+/g, ' ');
      name = name.trim();
      var body = {
        "name": name,
        "type": 'JS'
      };
      this.http.post<any>(url, body, options).subscribe(
          data => {
            this.nameExist = data.response;
          }
        );
      this.disableName = false;
      nameElement.classList.add(...this.class);
    }
  }

  // Validation for JoinEUIs
  validateId(id, index) {

    // Pattern validation
    this.patternError = false;
    let netIdRegExp = new RegExp(/^([0-9a-fA-F]{16})\/([1-9]|[1-5][0-9]|6[0-4])$/i);
    if (!netIdRegExp.test(id)) {
      this.patternError = true;
      this.trackingPattern[index] = true;
    } else {
      this.patternError = false;
      this.trackingPattern[index] = false;
    }

    if(!this.patternError) {
      // Verify if JoinEUI exists in database
      const headers = new HttpHeaders({'Content-Type':  'application/json'});
      let options =  {headers: headers};
      var url = ApiEndpoints.EXISTS_JOIN_EUI;
      var body = {
         "virtId": "0",
         "joinEUi": id
      };
      this.http.post<any>(url, body, options).subscribe(
           data => {
             this.trackingArr[index] = data.response;
             this.hasError = this.trackingArr[index];
          }
      );
    }

    // Verify if exists duplicates
    var prefixLength = parseInt(id.split("/")[1]);
    var prefix = this.hex2bin(id.split("/")[0], prefixLength);
    for (let i = 0; i < this.joinServerModel.joinEUIs.length; i++) {
      if (prefix == this.hex2bin(this.joinServerModel.joinEUIs[i], prefixLength) && i != index) {
        this.trackingCheck[index] = true;
        break;
      } else {
        this.trackingCheck[index] = false;
      }

      this.duplicateError = this.trackingCheck[index];
    }

    // Verify if exists any error
    this.disableSaveButton = false;
    for(let i in this.trackingPattern) {
      if(this.trackingPattern[i] == true) {
        this.disableSaveButton = true;
      }
    }
    for(let i in this.trackingCheck) {
      if(this.trackingCheck[i] == true) {
        this.disableSaveButton = true;
      }
    }
    for(let i in this.trackingArr) {
      if(this.trackingArr[i] == true) {
        this.disableSaveButton = true;
      }
    }
  }

  // Validation on last JoinEUI row
  validation(inputJoinEUI) {
    this.noValid = this.hasError = this.duplicatesExist = this.duplicateError = this.joinIdExist = false;

    if(inputJoinEUI != ''){
      if(inputJoinEUI.split("/").length == 1) inputJoinEUI = inputJoinEUI + '/64'
      let idRegExp = new RegExp(/^([0-9a-fA-F]{16})\/([1-9]|[1-5][0-9]|6[0-4])$/i);
      if (!idRegExp.test(inputJoinEUI)) {
        this.noValid = true;
      } else {
        this.noValid = false;
      }
      this.hasError = this.noValid;

      if(!this.noValid) {
        // Verify if JoinEUI exists in database
        const headers = new HttpHeaders({'Content-Type':  'application/json'});
        let options =  {headers: headers};
        var url = ApiEndpoints.EXISTS_JOIN_EUI;
        var body = {
          "virtId": "0",
          "joinEUi": inputJoinEUI
        };
        this.http.post<any>(url, body, options).subscribe(
            data => {
              this.joinIdExist = data.response;
                if (this.joinIdExist == true) {
                  this.hasError = true;
                } else {
                  this.hasError = false;
                }
            });
      }

      // Verify if exists duplicates
      var prefixLength = parseInt(inputJoinEUI.split("/")[1]);
      var prefix = this.hex2bin(inputJoinEUI.split("/")[0], prefixLength);
      for (let i of this.joinServerModel.joinEUIs) {
        if (prefix == this.hex2bin(i, prefixLength)) {
          this.duplicatesExist = true;
          break;
        } else {
          this.duplicatesExist = false;
        }
        this.duplicateError = this.duplicatesExist;
      }
    }

    // Verify if exist at least one JoinEUI
    this.doNotHaveJoinEUI = false;
    if(this.joinServerModel.joinEUIs.length == 0 && inputJoinEUI == "") {
      this.doNotHaveJoinEUI = true;
    } else {
      this.doNotHaveJoinEUI = false;
    }
  }

  addJoinEUI(joinEUI) {
    this.inputJoinEUI.nativeElement.value = '';
    if (joinEUI != '') {
      if(joinEUI.split("/").length == 1) joinEUI = joinEUI + '/64'
      this.joinServerModel.addJoinEUI(joinEUI);
      let index = this.joinServerModel.joinEUIs.length - 1;

      this.trackingArr[index] = this.joinIdExist;
      this.trackingCheck[index] = this.duplicatesExist;
      this.trackingPattern[index] = this.patternError;
      this.validateId(joinEUI, index);
      this.noValid = this.joinIdExist = this.hasError = this.duplicatesExist = this.doNotHaveJoinEUI = false;
    }
  }

  trackByFn(index, item) {
    return index; // or item.id
  }

  editJoinEUI(index, event) {
    this.joinServerModel.editJoinEUI(index, event.target.value);
  }

  removeJoinEUI(firstInput, index) {
    this.noValid = this.joinIdExist = this.hasError = this.duplicatesExist = this.disableSaveButton = this.patternError = this.doNotHaveJoinEUI = false;
    this.trackingArr.splice(index, 1);
    this.trackingPattern.splice(index, 1);
    this.trackingCheck.splice(index,1);
    this.joinServerModel.removeJoinEUI(index);
    for(let validateIndex = 0; validateIndex <= this.trackingCheck.length; validateIndex++){
      if (this.trackingCheck[validateIndex] === true) {
        this.validateId(this.joinServerModel.joinEUIs[validateIndex], validateIndex);
      }
    }
    for(let validateIndex = 0; validateIndex <= this.trackingArr.length; validateIndex++){
      if (this.trackingArr[validateIndex] === true) {
        this.validateId(this.joinServerModel.joinEUIs[validateIndex], validateIndex);
      }
    }
    for(let validateIndex = 0; validateIndex <= this.trackingPattern.length; validateIndex++){
      if (this.trackingPattern[validateIndex] === true) {
        this.validateId(this.joinServerModel.joinEUIs[validateIndex], validateIndex);
      }
    }
    if(this.joinServerModel.joinEUIs.length == 0 && firstInput == "") {
      this.doNotHaveJoinEUI = true;
    }
  }

  getAllOwnerWithSearch() {
    this.showSearch = true;
    var url = ApiEndpoints.GET_ALL_USERS;
    var body = {
      "username": ""
    };
    const headers = new HttpHeaders({
      'Content-Type':  'application/json',
      'Authorization': 'my-auth-token'
    });
    let options =  {headers: headers}
    this.http.post<Array<any>>(url, body, options).subscribe(
        data => {
          for(let index of data){
            if(index.isHidden == undefined || index.isHidden == "false") {
              this.ownerArray.push(index.username + ", " + index.firstName + " " + index.lastName);
            }
          }
        }
      );
  }

  // Get AllPlatform Call Function
  getPlatform() {
    var url = ApiEndpoints.PLATFORMS;
    const headers = new HttpHeaders({
      'Content-Type':  'application/json',
      'Authorization': 'my-auth-token'
    });
    let options =  {headers: headers}
    this.http.post<Array<any>>(url, options).subscribe(
        data => {
          for(let index of data){
            this.allPlatforms.push(index.platformId + ", " + index.platformName);
          }
        }
      );
  }

  validateURL(urlValue, urlElement){
    if(urlValue !== "") {
      this.validURL = true;
      this.errorValidURL = false;
      let idRegExp =   new RegExp(/^^(([a-zA-Z-][a-zA-Z0-9-]{1,63}(\.[a-zA-Z-][a-zA-Z0-9]{1,63})+)|((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[1-9])(\b|\.)(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])(\b|\.)(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])(\b|\.)(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[1-9])\b))(\:(102[4-9]|10[3-9][0-9]|1[1-9][0-9][0-9]|[2-9][0-9][0-9][0-9]|[1-5][0-9][0-9][0-9][0-9]|6[0-4][0-9][0-9][0-9]|65[0-4][0-9][0-9]|655[0-2][0-9]|6553[0-5])\b)?(((\/){0,1}[a-zA-Z-0-9\_\-])*(::)?([a-zA-Z-0-9\_\-])*)*$/);

      if (!idRegExp.test(urlValue) && urlElement.name == "url_js") {
        this.patternURL = false;
        this.errorPatternURL = true;
        urlElement.classList.remove(...this.class);
        urlElement.classList.add(...this.errorClass);
      } else if(!idRegExp.test(urlValue) && urlElement.name == "url_claim") {
        this.patternClaimURL = false;
        this.errorPatternClaimURL = true;
        urlElement.classList.remove(...this.class);
        urlElement.classList.add(...this.errorClass);
      } else if(idRegExp.test(urlValue) && urlElement.name == "url_js"){
        this.patternURL = true;
        this.errorPatternURL = false;
        urlElement.classList.remove(...this.errorClass);
        urlElement.classList.add(...this.class);
      } else if(idRegExp.test(urlValue) && urlElement.name == "url_claim") {
        this.patternClaimURL = true;
        this.errorPatternClaimURL = false;
        urlElement.classList.remove(...this.errorClass);
        urlElement.classList.add(...this.class);
      }
    } else {
      if(urlElement.name == "url_js") {
        urlElement.classList.remove(...this.class);
        urlElement.classList.add(...this.errorClass);
        this.patternURL = false;
        this.errorPatternURL = false;
        this.validURL = false;
        this.errorValidURL = true;
      } else {
        this.patternClaimURL = true;
        this.errorPatternClaimURL = false;
        urlElement.classList.remove(...this.errorClass);
      }
    }
  }

  saveJoinServer() {
    this.joinServerModel.name = this.joinServerModel.name.trim();
    var body: any = JSON.parse(JSON.stringify(this.joinServerModel));
    var url = ApiEndpoints.CREATE_JOIN_SERVER;
    this.http.post<any>(url, body).subscribe(
        data => {
          this.router.navigate(['/all-join']);
        }
      );
  }

  backClicked() {
    this._location.back();
  }


  ngOnInit() {

    this.getAllOwnerWithSearch();

    // Get AllPrimaryHub Call
    this.getPlatform();

    $(document).ready(function () {

      $('.ui.dropdown')
        .dropdown({
          allowAdditions: true
        });

    });
  }

}
